"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.home = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const home = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'home-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', 
            // eslint-disable-next-line max-len
            d: 'M9.50612 3.43557C9.78889 3.18814 10.2111 3.18814 10.4939 3.43557L16.4939 8.68557C16.6566 8.82798 16.75 9.03373 16.75 9.25V16C16.75 16.4142 16.4142 16.75 16 16.75H4C3.58579 16.75 3.25 16.4142 3.25 16V9.25C3.25 9.03373 3.34336 8.82798 3.50612 8.68557L9.50612 3.43557ZM4.75 9.59033V15.25H15.25V9.59033L10 4.99658L4.75 9.59033Z', fill: '#4B5563' })));
};
exports.home = home;
